import { MatPaginatorIntl } from '@angular/material/paginator';

export function getMkPaginatorIntl(): MatPaginatorIntl {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = 'Ставки по страница:';
  paginatorIntl.nextPageLabel = 'Следна страница';
  paginatorIntl.previousPageLabel = 'Претходна страница';
  paginatorIntl.firstPageLabel = 'Прва страница';
  paginatorIntl.lastPageLabel = 'Последна страница';
  paginatorIntl.getRangeLabel = (page, pageSize, length) => {
    if (length === 0 || pageSize === 0) {
      return `0 од ${length}`;
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return `${startIndex + 1} – ${endIndex} од ${length}`;
  };

  return paginatorIntl;
}